import { Text } from "@minuthq/meatball-ui-react"

import { ParadiseOverviewExpandable } from "src/components/Paradise/ParadiseOverviewExpandable"
import { ParadiseSettingStatic } from "src/components/Paradise/ParadiseSettings/ParadiseSettingStatic"
import { CopyWrapper } from "src/components/Paradise/sharedStyles"
import { TWarehouse } from "src/data/ecommerce/ecommerceTypes"
import { prettifyApiFieldValue } from "src/data/orders/orderUtils"
import { CopyText } from "src/ui/CopyText/CopyText"
import { formatUtcDate } from "src/utils/l10n"

export function ParadiseWarehouseOverview({
  warehouse,
}: {
  warehouse: TWarehouse
}) {
  return (
    <ParadiseOverviewExpandable rawJson={warehouse}>
      <ParadiseSettingStatic
        title="ID"
        value={
          <CopyWrapper>
            <Text variant="bodyS">{warehouse.id}</Text>
            <CopyText value={warehouse.id} copiedText="Copied!" />
          </CopyWrapper>
        }
      />
      <ParadiseSettingStatic
        title="Name"
        value={
          <CopyWrapper>
            <Text variant="bodyS">{prettifyApiFieldValue(warehouse.name)}</Text>
            <CopyText
              value={prettifyApiFieldValue(warehouse.name)}
              copiedText="Copied!"
            />
          </CopyWrapper>
        }
      />
      <ParadiseSettingStatic
        title="Warehouse Management System"
        value={
          <CopyWrapper>
            <Text variant="bodyS">
              {prettifyApiFieldValue(warehouse.warehouse_management_system)}
            </Text>
            <CopyText
              value={prettifyApiFieldValue(
                warehouse.warehouse_management_system
              )}
              copiedText="Copied!"
            />
          </CopyWrapper>
        }
      />
      <ParadiseSettingStatic
        title="Legal Entity"
        value={
          <CopyWrapper>
            <Text variant="bodyS">
              {prettifyApiFieldValue(warehouse.legal_entity)}
            </Text>
          </CopyWrapper>
        }
      />
      <ParadiseSettingStatic
        title="Stock quantity updated at"
        value={
          <CopyWrapper>
            <Text variant="bodyS">
              {formatUtcDate({
                date: warehouse.stock_quantity_updated_at,
              })}
            </Text>
          </CopyWrapper>
        }
      />
      <ParadiseSettingStatic
        title="Updated at"
        value={
          <CopyWrapper>
            <Text variant="bodyS">
              {formatUtcDate({
                date: warehouse.updated_at,
              })}
            </Text>
          </CopyWrapper>
        }
      />
      <ParadiseSettingStatic
        title="Created at"
        value={
          <CopyWrapper>
            <Text variant="bodyS">
              {formatUtcDate({
                date: warehouse.created_at,
              })}
            </Text>
          </CopyWrapper>
        }
      />
    </ParadiseOverviewExpandable>
  )
}
